module.exports = ".not-active {\r\n    pointer-events: none;\r\n    cursor: default;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/admin/breadcrumbs/breadcrumbs.component.css
// module id = ./src/app/layout/admin/breadcrumbs/breadcrumbs.component.css
// module chunks = main